import { render, staticRenderFns } from "./HistoricoLeiloes.vue?vue&type=template&id=714efc95"
import script from "./HistoricoLeiloes.vue?vue&type=script&lang=js"
export * from "./HistoricoLeiloes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports